// src/config/sidebarItems.js
import {
  PostAdd,
  AccountTree,
  EditNote,
  Receipt,
  PersonAddAlt1,
  PeopleAlt,
  Drafts,
  Mail,
  ForwardToInbox,
  EditCalendar,
  EventAvailable,
  Business,
  Password,
  Lock,
  HelpOutline,
  AdminPanelSettings,
  Groups,
  AccountBalanceWallet,
  History,
  CreditCard,
  Payments,
} from "@mui/icons-material";

const sidebarItems = [
  {
    title: "Expenses",
    items: [
      {
        to: "/expenses",
        label: "Expense Tracker",
        icon: Payments,
        description: "Record personal and business expenses, and view spending by period",
      },
    ],
  },

  {
    title: "Admin",
    items: [
      {
        to: "/admin/overview",
        label: "Platform Overview",
        icon: AdminPanelSettings,
        description: "Admin: platform-wide stats, users, and activity",
        adminOnly: true,
      },
      {
        to: "/admin/users",
        label: "Users",
        icon: Groups,
        description: "Admin: browse and inspect all platform users",
        adminOnly: true,
      },
      {
        to: "/admin/collections",
        label: "Collections",
        icon: AccountBalanceWallet,
        description: "Admin: all wallet cash-in collections",
        adminOnly: true,
      },
      {
        to: "/admin/payouts",
        label: "Payouts",
        icon: Receipt,
        description: "Admin: all wallet-to-bank payouts",
        adminOnly: true,
      },
      {
        to: "/admin/activity",
        label: "Activity",
        icon: History,
        description: "Admin: platform-wide account and payment activity",
        adminOnly: true,
      },
      {
        to: "/admin/support",
        label: "Manage Tickets",
        icon: AdminPanelSettings,
        description: "Admin: view and reply to all tickets",
        adminOnly: true,
      },
    ],
  },

   

  {
    title: "Cards",
    items: [
      {
        to: "/cards",
        label: "Virtual Cards",
        icon: CreditCard,
        description: "Issue and manage USD virtual cards",
      },
      {
        to: "/cardholders",
        label: "Cardholders",
        icon: PeopleAlt,
        description: "People your cards are issued to",
      },
    ],
  },

  // {
  //   title: "Cards Management",
  //   items: [
  //     {
  //       to: "/new-cardholder",
  //       label: "Add Cardholder",
  //       icon: PersonAddAlt1,
  //       description: "Register a new virtual or physical card",
  //     },
  //     {
  //       to: "/cardholders",
  //       label: "Manage Cardholders",
  //       icon: PeopleAlt,
  //       description: "View and manage all card users",
  //     },
  //   ],
  // },
  {
    title: "Messaging (SMS)",
    items: [
      {
        to: "/bulk-sms",
        label: "Bulk SMS",
        icon: Drafts,
        description: "Send mass text campaigns to your contacts",
      },
      {
        to: "/1-to-1-sms",
        label: "One-to-One SMS",
        icon: Mail,
        description: "Send personalized messages to single recipients",
      },
      {
        to: "/messages",
        label: "Message Inbox",
        icon: ForwardToInbox,
        description: "View sent and received messages",
      },
    ],
  },
    {
    title: "Sender Ids",
    items: [
      {
        to: "/sender-ids-list",
        label: "Sender IDs List",
        icon: AccountTree,
        description: "Manage approved SMS sender IDs",
      },
      {
        to: "/new-sender-id",
        label: "Request Sender ID",
        icon: EditNote,
        description: "Apply for new sender name approval",
      },
    ],
  },
  // {
  //   title: "Events & Scheduling",
  //   items: [
  //     {
  //       to: "/new-event",
  //       label: "Create Event",
  //       icon: EditCalendar,
  //       description: "Schedule and organize business events",
  //     },
  //     {
  //       to: "/events",
  //       label: "Event List",
  //       icon: EventAvailable,
  //       description: "View and manage all events",
  //     },
  //   ],
  // },
  {
    title: "Support",
    items: [
      {
        to: "/support",
        label: "Help & Support",
        icon: HelpOutline,
        description: "Submit and track your support tickets",
      },
    ],
  },
  {
    title: "Settings",
    items: [
      {
        to: "/business-info",
        label: "Business Information",
        icon: Business,
        description: "Manage your company profile and details",
      },
      {
        to: "/change-password",
        label: "Change Password",
        icon: Password,
        description: "Update your account security credentials",
      },
      {
        to: "/change-pin",
        label: "Change PIN",
        icon: Lock,
        description: "Modify your transaction security PIN",
      },
      {
        to: "/selcompesa-account",
        label: "SelcomPesa Account",
        icon: AccountBalanceWallet,
        description: "Save your SelcomPesa mobile number for instant withdrawals",
      },
       {
        to: "/new-api-key",
        label: "Create API Key",
        icon: PostAdd,
        description: "Generate secure API credentials for integration",
      },
    ],
  },
];

export default sidebarItems;
